module.exports = __webpack_public_path__ + "img/Curso_InglesNinos.f6db30ba.png";